<template>
    <div>
        <div class="panel-sub-heading headingLarge">
            <span class="h5 display-6 markedBottom bold">{{ lang('review') }}</span>
            <span v-if="isPiiMasked" class="float-right float-end">
                <a class="btn btn-sm btn-default btn-with-label" @click="unmaskHandler">
                    <span class="btn-label"><i class="fas fa-pencil-alt"></i></span>
                    {{lang('unmask')}}
                </a>
            </span>
        </div>
        <div class="exactCenter" v-if="is_loading">
            <div class="card">
                <div class="card-header">
                    <span class="h5 display-6 bold">{{ lang('please_wait') }}</span>
                </div>
                <div class="card-body text-center">
<!--                    <vue-spinner :font-size="15" :message="loading_message"></vue-spinner>-->
                    <div class="d-flex justify-content-center">
                        <div  class="spinner-border" role="status" aria-hidden="true"></div>
                    </div>
                    <span style="font-size: 15px;">{{loading_message}}</span>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="row" id="snapshot_block">
                    <div class="col-md-6">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{lang('snapshot')}}</span>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <np-entry
                                        :label="lang('legal_name')"
                                        mode="inline"
                                        v-model="merchant.legal_name">
                                </np-entry>
                                <np-entry
                                        :label="lang('application_reference')"
                                        mode="inline"
                                        v-model="merchant.application_reference">
                                </np-entry>
                            </div>
                            <div class="col-6">
                                <np-entry
                                        :label="lang('status')"
                                        mode="inline"
                                        :formatter="formatMerchantStatus"
                                        v-model="merchant.application_status_external_id">
                                </np-entry>
                                <np-entry
                                        :label="lang('signature_date')"
                                        mode="inline"
                                        v-model="signerOwner.signature_date">
                                </np-entry>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{lang('application_task_progress')}}</span>
                        </div>
                        <template v-for="substatus in substatuses">
                            <np-progress v-if="getSubstatusDescription(substatus) !== ''"
                                :key="`application_substatus_${substatus.substatus_external_id}`"
                                :label="getSubstatusDescription(substatus)"
                                :mode="substatus_mapping[substatus.status]['mode']"
                                :state="substatus_mapping[substatus.status]['state']">
                            </np-progress>
                        </template>

                    </div>

                    <div class="col-12" v-if="mainDataLoaded && !isSignerUser">
                        <merchant-consent
                                @extra-consent-opened-checked="toggleExtraConsent($event)"
                                :show_gdpr_block="need_gdpr_block"
                                :need_extra_consent_block="show_extra_consent">
                        </merchant-consent>
                    </div>

                    <div class="col-12" v-if="!!$route.params.signature_status && isAwaitingSignature">
                        <div class="mt-5">
                            <div v-if="$route.params.signature_status == 'declined'">
                                <np-notice :notice="lang('signature_process_declined')" :notice-class="'alert-danger'"
                                           :dismissable="false"></np-notice>
                            </div>
                            <div v-if="$route.params.signature_status == 'expired'">
                                <np-notice :notice="lang('signer_url_expired')" :notice-class="'alert-danger'"
                                           :dismissable="false"></np-notice>
                                <div class="col-12 mt-4" style="border-top: 1px solid #b2c6d0">
                                    <div class="my-3">
                                        <button @click="refreshSignatureUrl" class="btn btn-default">
                                            {{lang('refresh_signature_url')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="isAwaitingSignature && principalcanSign && (!principalHaveSigned || signature_type == 'PAPER')" class="col-md-12">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{lang('signature')}}</span>
                        </div>
                        <div v-if="!principalHaveSigned">
                            <div class="my-3">
                                <button @click="doSignature" class="btn btn-default btn-block">
                                    {{ lang('sign_agreement') }}
                                </button>
                            </div>
                            <div class="my-3">
                                <np-notice class="col-md-6" style="padding-left: 0px;" :notice-class="'alert-warning'" :notice="lang('please_sign_agreement')"></np-notice>
                            </div>
                        </div>
                        <np-notice v-if="signature_type == 'PAPER'"
                                   :notice="lang('paper_signature_description')"></np-notice>
                    </div>
                    <!--<editor-fold defaultstate="collapsed" desc="Signing Status Table">-->
                    <div v-if="isAwaitingSignature && principalcanSign && multiplePrincipalsCanSign && !isSignerUser" class="col-md-12">
                            <div class="panel-sub-heading headingSmall"></div>
                            <div class="row">
                                <div class="col-12">
                                    <table class="table table-shades table-text">
                                        <colgroup>
                                            <col class="col-md-020p">
                                            <col class="col-md-015p">
                                            <col class="col-md-020p">
                                            <col class="col-md-015p">
                                            <col class="col-md-015p">
                                            <col class="col-md-015p">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>{{lang('name')}}</th>
                                                <th>{{lang('phone')}}</th>
                                                <th>{{lang('field_email')}}</th>
                                                <th>{{lang('status')}}</th>
                                                <th>{{lang('signature_date')}}</th>
                                                <th>{{lang('action')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody class="signatoryItemsBlock">
                                            <tr v-for="(signatory, index) in signatories">
                                                <td>{{signatory.text}}</td>
                                                <td>{{`${formatPhoneCode(signatory.phone_code)} ${signatory.phone_no}`}}</td>
                                                <td>{{signatory.email}}</td>
                                                <td>{{formatSignerStatus(signatory.signer_signed)}}</td>
                                                <td>{{signatory.signature_date}}</td>
                                                <td>
                                                    <a v-if="signatory.signer_signed !== '1' && !matchesUserEmail(signatory.email)"
                                                       @click.prevent="signerSignature(signatory)"
                                                       class="pull-right btn btn-default width_100p marginBottom5">
                                                       {{lang('send_signature_link')}}
                                                    </a>
                                                    <span v-else> - </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    </div>
                    <!--</editor-fold>  -->
                    <div class="col-12" v-if="statusNotices.hasOwnProperty(applicationStatusKey) && mainDataLoaded">
                        <div class="my-3">
                            <np-notice
                                    v-show="getStatusNoticeMessage(applicationStatusKey).length > 0"
                                    :notice-class="statusNotices[applicationStatusKey]['notice_class']"
                                    :notice="getStatusNoticeMessage(applicationStatusKey)"
                            ></np-notice>
                        </div>
                    </div>

                    <div v-if="showSetMfaDevice" class="col-md-6">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{lang('user_settings')}}</span>
                        </div>
                        <div class="my-3">
                            <add_mfa_device></add_mfa_device>
                        </div>
                        <div class="my-3">
                            <np-notice
                                    notice-class="alert-warning"
                                    :notice="lang('set_mfa_device_notice')"
                            ></np-notice>
                        </div>
                    </div>
                    <div v-else-if="showSetPassword" class="col-md-6">
                        <div class="panel-sub-heading headingSmall">
                            <span class="markedBottom">{{lang('set_password')}}</span>
                        </div>
                        <div class="my-3">
                            <button class="btn btn-default" type="button" data-bs-toggle="modal" data-bs-target="#setPasswordModal">{{lang('set_password')}}</button>
                        </div>
                    </div>
                    <div class="col-12">

                        <div class="my-3 float-right float-end" v-if="!isSignerUser">
                            <button type="button" class="btn btn-default" v-if="mainDataLoaded && isOpenApplication && satisfy_extra_consent_block"
                                    :disabled="(quote.gdpr_agreement !== '1' || quote.marketing_opt_in === '' || disableContinueBtn)"
                                    @click="lockApplication"> {{lang('confirm_and_submit')}} {{!!disableContinueBtn ? '...' : ''}}</button>
                            <span style="color:black" v-if="isUnlockable">{{lang('unlock_text')}}</span>
                            <button type="button" class="btn btn-default" v-if="isUnlockable"
                                    @click="unlockApplication"> {{lang('unlock')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form id="review_form"
              ref="review_form" class="content-inner formValidation">
            <div ref="business_block">
                <div class="row" id="review">
                    <div class="col-md-12 col-12">
                        <div v-if="sections.length > 0" id="accordion">
                            <div v-for="(section, index) in sections" :key="index" class="card">
                                <div v-if="!(section.section_id === 'section_generated_documents' && !hasAgreementDocuments)"
                                     class="card-header cursorPointer" @click="toggleSection(section)" :data-section-id="section.section_id"
                                     :id="`heading_${index}`" data-bs-toggle="collapse" :data-bs-target="`#collapse_${index}`"
                                     aria-expanded="true" :aria-controls="`collapse_${index}`">
                                    <h5 class="mb-0">
                                        <span v-if="section.is_open" class="caretSign rotate"><i
                                                class="fa fa-caret-up"></i></span>
                                        <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                        <span>{{getSectionTitle(section)}}</span>
                                        <span v-if="section.section_id === 'section_documents' && section.is_open && userCanEditDocumentsSession">
                                            <span v-if="!section.editing" class="float-right float-end">
                                                <a class="btn btn-sm btn-default btn-with-label"
                                                   @click="(event) => { event.stopPropagation(); section.editing = true;}"><span
                                                    class="btn-label"><i class="fas fa-pencil-alt"></i></span> {{lang('edit')}}</a>
                                            </span>
<!--                                            <span v-else class="float-right float-end">-->
<!--                                                <a class="btn btn-sm btn-success btn-with-label"-->
<!--                                                   @click="doSave(section)"><span-->
<!--                                                    class="btn-label"><i class="fas fa-check"></i></span> {{lang('done')}}</a>-->
<!--                                             </span>-->
                                        </span>
                                        <span v-else-if="!!can_edit && section.is_editable && section.is_open && isOpenApplication && !isSignerUser" class="float-right float-end">
                                            <span v-if="!section.editing && isOpenApplication && !isMaskedSection(section.section_id)" class="float-right float-end">
                                                <a class="btn btn-sm btn-default btn-with-label"
                                                   @click="(event) => { event.stopPropagation(); section.editing = true;}"><span
                                                        class="btn-label"><i class="fas fa-pencil-alt"></i></span> {{lang('edit')}}</a>
                                            </span>
<!--                                            <span v-else class="float-right float-end">-->
<!--                                                <a class="btn btn-sm btn-success btn-with-label"-->
<!--                                                   @click="doSave(section)"><span-->
<!--                                                        class="btn-label"><i class="fas fa-check"></i></span> {{lang('done')}}</a>-->
<!--                                             </span>-->
                                        </span>
                                        <span v-else class="float-right float-end">
                                            <span v-if="section.wasRecentlyUpdated && section.hasRequiredData" class="float-right float-end">
                                                <i class="fa fa-check iconOrange"></i>
                                            </span>
                                            <span v-else-if="section.hasRequiredData" class="float-right float-end">
                                                <i class="fa fa-check green"></i>
                                            </span>
                                            <span v-else class="float-right float-end">
                                                <i class="fa fa-exclamation-circle iconOrange"></i>
                                             </span>
                                        </span>
                                    </h5>
                                </div>
                                <div v-if="section.is_open" :aria-labelledby="`heading_${index}`" class="card-body">
                                    <div v-if="section.section_id === 'section_business_information'">
                                        <business-info v-if="section.editing" is_reviewing @close_review_section="closeSection(section)"></business-info>
                                        <view-business-info is_reviewing v-else></view-business-info>
                                    </div>
                                    <div v-if="section.section_id === 'section_equipment'">
                                        <equipments v-if="section.editing" is_reviewing @close_review_section="closeSection(section)"></equipments>
                                        <view-equipments is_reviewing v-else></view-equipments>
                                    </div>
                                    <div v-if="section.section_id === 'section_pricing'">
                                        <pricing v-if="section.editing" is_reviewing @close_review_section="closeSection(section)"></pricing>
                                        <view-pricing is_reviewing v-else></view-pricing>
                                    </div>
                                    <div v-if="section.section_id === 'section_business_details'">
                                        <business-details v-if="section.editing && !isPiiDataMaskedBank" is_reviewing  :ref="section.section_id" @close_review_section="closeSection(section)"></business-details>
                                        <view-business-details is_reviewing v-else></view-business-details>
                                    </div>
                                    <div v-if="section.section_id === 'section_trading_details'">
                                        <trading-details v-if="section.editing" is_reviewing  :ref="section.section_id" @close_review_section="closeSection(section)"></trading-details>
                                        <view-trading-details is_reviewing v-else></view-trading-details>
                                    </div>
                                    <div v-if="section.section_id === 'section_principals'" class="marginTop10">
                                        <principals v-if="section.editing && !isPiiDataMaskedOwner" is_reviewing  :ref="section.section_id" @close_review_section="closeSection(section)"></principals>
                                        <view-principals is_reviewing v-else></view-principals>
                                    </div>
                                    <div v-if="section.section_id === 'section_documents'">
                                        <documents v-if="section.editing && !isPiiDataMaskedDocument" is_reviewing  :ref="section.section_id"></documents>
                                        <view-documents v-else is_reviewing></view-documents>
                                    </div>
                                    <div v-if="section.section_id === 'section_generated_documents'">
                                        <view-generated-documents is_reviewing></view-generated-documents>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4" style="border-top: 1px solid #b2c6d0">
                <div class="col-12">
                    <div class="my-3">

                        <!-- Disable button 'go_back' if data still loading to avoid navigation -->
                        <button class="btn btn-danger me-1" :disabled="loading_document_upload" v-if="isOpenApplication" @click="backPage"> {{lang('go_back')}}
                        </button>

                        <button type="button" class="btn btn-default me-1" v-if="mainDataLoaded && isOpenApplication && satisfy_extra_consent_block && !isSignerUser"
                                :disabled="(quote.gdpr_agreement !== '1' || quote.marketing_opt_in === '' || disableContinueBtn)"
                                @click="lockApplication"> {{lang('confirm_and_submit')}} {{!!disableContinueBtn ? '...' : ''}}</button>

                        <button type="button" class="btn btn-default me-1" v-if="isUnlockable"
                                @click="unlockApplication"> {{lang('unlock')}}</button>
                    </div>
                </div>
            </div>

            <np-pdf-modal url="/application/viewgdprdocument/" :title="lang('elavon_privacy_policy')"  id="elavon-gdpr-pdf"></np-pdf-modal>
        </form>

        <div id="setPasswordModal" class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{lang('please_set_a_password')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="lang('close')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body py-3">
                        <form @submit.prevent="submitPrevent" id="set-password-form" name="set_password_form"
                              class="content-inner">
                            <div class="row">
                                <div class="col-12">
                                    <p v-html="lang('tooltip_password')">
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <np-input
                                        :label="lang('placeholder_password')"
                                        :id="'new_password'"
                                        :name="'new_password'"
                                        :no-wrapper="true"
                                        :addon-on-left="true"
                                        :required="true"
                                        :maxlength="20"
                                        :minlength="12"
                                        aria-autocomplete="off"
                                        type="password"
                                        v-model="password_form.new_password">
                                        <template #addon>
                                        <span><i class="fa fa-lock"></i></span>
                                        </template>
                                    </np-input>
                                    <np-input
                                        :label="lang('placeholder_conf_password')"
                                        :id="'conf_password'"
                                        :name="'conf_password'"
                                        :no-wrapper="true"
                                        :addon-on-left="true"
                                        :required="true"
                                        :maxlength="20"
                                        :minlength="12"
                                        aria-autocomplete="off"
                                        type="password"
                                        v-model="password_form.conf_password">
                                        <template #addon>
                                        <span><i class="fa fa-lock"></i></span>
                                        </template>
                                    </np-input>
                                </div>
                                <div v-if="password_errors.length > 0" class="col-12">
                                    <div class="alert_alertContainer alert alert-danger" role="alert">
                                        <div>
                                            <template v-for="(error, index) in password_errors">
                                                <span> {{ index + 1 }}. {{ error }}</span>
                                                <br>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12 col-md-12">
                                    <div class="float-right float-end">
                                        <button type="button" class="btn btn-secondary mx-2" data-bs-dismiss="modal">
                                            {{ lang('cancel') }}
                                        </button>
                                        <button type="button" class="btn btn-default"
                                                @click="savePassword">{{ lang('submit') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css">
    .exactCenter {
        width:250px;
        height:200px;
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -100px;
        margin-left: -100px;
        z-index: 50000;
    }
</style>

<script>
    import BusinessInformation from '../business/business_info.vue';
    import ViewBusinessInformation from '../business/view_business_info.vue';
    import Equipments from '../equipment_pricing/equipments.vue';
    import ViewEquipments from '../equipment_pricing/view_equipments.vue';
    import ViewPricing from '../equipment_pricing/view_pricing.vue';
    import Pricing from '../equipment_pricing/pricing.vue';
    import BusinessDetails from '../business/business_details.vue';
    import ViewBusinessDetails from '../business/view_business_details.vue';
    import TradingDetails from '../outlet/trading.vue';
    import ViewTradingDetails from '../outlet/view_trading.vue';
    import Principal from '../principal/index.vue';
    import ViewPrincipal from '../principal/view_principal.vue';
    import Documents from '../document/index.vue';
    import ViewDocuments from '../document/view.vue';
    import ViewGeneratedDocuments from '../document/view_generated.vue';
    import MerchantConsent from './merchant_consent.vue';
    import applicationMixin from "../../../utils/application-mixin";
    import documentMixin from "../../../utils/document-mixin";
    import navigationMixin from "../../../utils/navigation-mixin";
    import * as types from "../../../stores/constants";
    import {mapActions, mapState} from 'pinia';
    import Spinner from 'vue-simple-spinner'
    import {NPProgress, NPRadios, NPNotice, NPCheckBox, NPInput, NPPdfModal} from "netpify/components";
    import {MerchantData, Quote} from "../../../entities";
    import {
        APP_STATUS_AWAITING_BOARDING_COMPLETE,
        APP_STATUS_BOARDING_COMPLETE,
        APP_STATUS_SUBMISSION_FAILED
    } from "../../../stores/constants";
    import useApplicationStore from "../../../stores/application_module";
    import useModuleStore from "../../../stores";
    import AddMfaDevice from './add_mfa_device.vue';

    export default {
        name: "index",
        mixins: [applicationMixin, documentMixin, navigationMixin],
        components: {
            'business-info': BusinessInformation,
            'view-business-info': ViewBusinessInformation,
            'equipments': Equipments,
            'pricing': Pricing,
            'view-equipments': ViewEquipments,
            'business-details': BusinessDetails,
            'view-business-details': ViewBusinessDetails,
            'trading-details': TradingDetails,
            'view-trading-details': ViewTradingDetails,
            'principals': Principal,
            'view-principals': ViewPrincipal,
            'documents': Documents,
            'view-documents': ViewDocuments,
            'view-generated-documents': ViewGeneratedDocuments,
            'view-pricing': ViewPricing,
            'merchant-consent': MerchantConsent,
            'np-progress': NPProgress,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-notice': NPNotice,
            'np-checkbox': NPCheckBox,
            'vue-spinner':     Spinner,
            'np-pdf-modal': NPPdfModal,
            'add_mfa_device': AddMfaDevice,
        },
        metaInfo() {
            return {
                title: this.lang('tab_review')
            }
        },
        beforeRouteEnter(to, from, next) {

            next(vm => {

                if (vm.isSignerUser && (vm.application_root_path.includes('/application/add') || vm.application_root_path.includes('/application/edit'))) {
                    // location.href = '/';
                }

                if ((vm.isOpenApplication && !vm.isSignerUser) || vm.showEditDocumentSignatory) {
                    if (vm.mainDataLoaded) {
                        if (!vm.validateDocuments(false)) {
                            if (vm.isPiiDataMaskedDocument && vm.isSignerUser) {
                                // When UI is masked and there missing documents, show an error message
                                // notify there are pending documents to upload
                                vm.notifyInfo(vm.lang("document_upload"), vm.lang("pii_masked_pending_document_upload"));
                            }
                            vm.backPage();
                        }
                    }
                }

                vm.setAppPageTitle(vm.page_label);
                // vm.openFirstSection()
            })
        },
        beforeRouteLeave(to, from, next) {
            let vm = this;
            let included_specific_url = to.fullPath.includes('/application/edit') ||
                to.fullPath.includes('/documents') || to.fullPath.includes('/upload_documents');
            if ((vm.isOpenApplication || vm.merchantToUpload || vm.hasMerchantControl) && !vm.isSignerUser && !vm.isSoleTrader &&
                included_specific_url && !vm.isPiiDataMaskedDocument) {
                vm.merchant['signatories_upload_documents_flag'] = '0';
            }
            next();
        },
        data: function () {
            return {
                page_label: 'tab_review',
                loading_message: '',
                is_loading: false,
                statusCheckInterval: null,
                agreemmentDocumentInterval: null,
                need_gdpr_block: false,
                need_extra_consent: false,
                extra_consent_opened_and_checked: false,
                sections: [ //quote steps (step 1 should not be editable at this point)
                    {
                        is_editable: true,
                        editing: false,
                        is_open: false,
                        label: "tab_business_information",
                        section_id: "section_business_information",
                        section_name: 'BUSINESS_INFO',//'BUSINESS_INFO',
                        form_name: `[name='business_information_form']`,//'#form',//'business_information_form',
                        wasRecentlyUpdated: false,
                        hasRequiredData: false,
                        entity_type:'QUOTE',
                    },
                    {
                        is_editable: true,
                        editing: false,
                        is_open: false,
                        label: "tab_equipment_selection",
                        section_id: "section_equipment",
                        section_name: 'EQUIPMENTS',
                        form_name: `[name='equipment_form']`,
                        wasRecentlyUpdated: false,
                        hasRequiredData: false,
                        entity_type:'OUTLET',
                    },
                    {
                        is_editable: true,
                        editing: false,
                        is_open: false,
                        label: "tab_pricing",
                        section_id: "section_pricing",
                        section_name: 'PRICING',
                        form_name: `[name='pricing_form']`,
                        wasRecentlyUpdated: false,
                        hasRequiredData: false,
                        entity_type:'OUTLET',
                    },
                    {
                        is_editable: true,
                        editing: false,
                        is_open: false,
                        label: "tab_business_details",
                        section_id: "section_business_details",
                        section_name: 'BUSINESS_OUTLET_BANK',
                        form_name: `[name='business_details_form']`,
                        wasRecentlyUpdated: false,
                        hasRequiredData: false,
                        entity_type:'APPLICATION',
                    },
                    {
                        is_editable: true,
                        editing: false,
                        is_open: false,
                        label: "tab_trading_details",
                        section_id: "section_trading_details",
                        section_name: 'OUTLET_INFORMATION',
                        form_name: `[name='outlet_information_form']`,
                        wasRecentlyUpdated: false,
                        hasRequiredData: false,
                        entity_type:'APPLICATION',
                    },
                    {
                        is_editable: true,
                        editing: false,
                        is_open: false,
                        label: "tab_principals",
                        section_id: "section_principals",
                        section_name: 'PRINCIPAL',
                        form_name: `[name='principals_form']`,
                        wasRecentlyUpdated: false,
                        hasRequiredData: false,
                        entity_type:'APPLICATION',
                    },
                    {
                        is_editable: true,
                        editing: false,
                        is_open: false,
                        label: "tab_supporting_documents_upload",
                        section_id: "section_documents",
                        section_name: '',
                        form_name: `[name='document_upload_form']`,
                        wasRecentlyUpdated: false,
                        hasRequiredData: false,
                        entity_type:'APPLICATION',
                    },
                    {
                        is_editable: false,
                        editing: false,
                        is_open: false,
                        label: "tab_generated_documents",
                        section_id: "section_generated_documents",
                        wasRecentlyUpdated: false,
                        hasRequiredData: true,
                        entity_type:'APPLICATION',
                    },
                ],
                statusNotices: {
                    'DOCUMENT_PACKET_GENERATION_FAILED': {
                        'notice_class': 'alert-warning',
                        'message': 'please_unlock_and_fix_error',
                    },
                    'SUBMISSION_FAILED': {
                        'notice_class': 'alert-warning',
                        'message': 'submission_failed_notice',
                    },
                    'BOARDING_IN_PROGRESS': {
                        'notice_class': 'alert-success',
                        'message': 'boarding_in_progress_notice',
                    },
                    'AWAITING_BOARDING_COMPLETE': {
                        'notice_class': 'alert-success',
                        'message': 'boarding_in_progress_notice',
                    },
                    'BOARDING_COMPLETE': {
                        'notice_class': 'alert-success',
                        'message': null,
                    },
                },
                allowedPaypalBoardingStatuses : [
                    'AWAITING_BOARDING_COMPLETE', 'BOARDING_IN_PROGRESS', 'BOARDING_COMPLETE'
                ],
                substatus_mapping: {
                    "1": {'mode': 'info', 'state': this.lang('in_progress')},
                    "2": {'mode': 'failed', 'state': this.lang('failed')},
                    "3": {'mode': 'success', 'state': this.lang('completed')},
                    "4": {'mode': 'archived', 'state': this.lang('archived')}
                },
                signature_type: '',
                review_load_complete: false,
                app_chain_change:{
                    quote: 0,
                    quote_data: {},
                    merchant: 0,
                    merchant_data: {},
                    outlet: 0,
                    outlet_data: {}
                },
                document_categories_validation_rules: {
                    'PROOF_OF_ID' : {
                        minimum: 1,
                        unique: true,
                        count: 0,
                        catalogue:[]
                    },
                    'PROOF_OF_ADDRESS' : {
                        minimum: 1,
                        unique: false,
                        count: 0,
                        catalogue:[]
                    },
                    'PROOF_OF_BANK' : {
                        minimum: 1,
                        unique: false,
                        count: 0,
                        catalogue:[]
                    },
                    'PROOF_OF_BUSINESS' : {
                        minimum: 1,
                        unique: false,
                        count: 0,
                        catalogue:[]
                    },
                },
                password_form: {
                    new_password: '',
                    conf_password: '',
                },
                password_errors: [],
                is_reviewing: true,
                is_state_changed : {
                    application: false,
                    quote: false,
                    outlet: false,
                }
            };
        },
        setup(){
            //replace app_chain and application
            const appStore = useApplicationStore()

            return {appStore}
        },
        methods: {
            ...mapActions(useApplicationStore, [types.COMMIT_APPLICATION, types.COMMIT_QUOTE, types.FETCH_APPLICATION_DATA]),
            ...mapActions(useApplicationStore, [types.SET_MERCHANT_VALIDATION_ERRORS, types.SET_APPLICATION_STATUS]),
            submitPrevent: function() {

            },
            getStatusNoticeMessage: function (applicationStatusKey) {
                //console.log('getStatusNoticeMessage => ', applicationStatusKey, this.allowedPaypalBoardingStatuses);
                let message = "";
                let notice_message = this.statusNotices.hasOwnProperty(applicationStatusKey) &&
                    this.statusNotices[applicationStatusKey].hasOwnProperty('message')
                    ? this.statusNotices[applicationStatusKey].message : null;

                if (notice_message) {
                    if (applicationStatusKey === 'SUBMISSION_FAILED') {
                        message += this.getGeneralInfoText(notice_message).replace('%0%', this.support_phone );
                    } else {
                        message += this.getGeneralInfoText(notice_message)
                    }
                }

                if (this.allowPayPalBoarding && this.allowedPaypalBoardingStatuses.includes(applicationStatusKey)) { // && this.payPalBoardingLink.length > 0
                    message += `<br><br><a href="${this.payPalBoardingLink}"><strong>${this.lang('paypal_notice')}</strong></a>`;
                }

                return message;
            },
            closeSection: function (section) {
                // if(section.section_id == "section_business_details" ||section.section_id == "section_trading_details" ||section.section_id == "section_principals") {
                    // if(!!this.$refs[section.section_id]) {
                    //     //console.log(this.$refs[section.section_id]);
                    //     // this.$refs[section.section_id].doReviewSave(() => section.editing = false);
                    // }
                // }
                section.editing = false;
                section.is_open = false;
            },
            // refetchQuoteData: async function (){
            //     let app_reference = this.$route.params.application_reference;
            //     if (!!this.merchant_user_access && this.merchant_user_access.hasOwnProperty('application')) {
            //         let application = this.merchant_user_access.application.find(obj => {
            //             return obj.application_reference === app_reference
            //         })
            //
            //         if (!!application) {
            //             let payload = {
            //               'user_external_id': this.user.user_external_id,
            //               'quote_external_id': application.quote_external_id,
            //             }
            //             //fetch and commit Quote Data
            //             await this[types.FETCH_QUOTE_DATA](payload);
            //         }
            //     }
            // },
            // fetchApplicationData: function (application_reference) {
            //     if (application_reference !== '' && typeof application_reference !== 'undefined') {
            //
            //       let payload = {
            //           application_reference: application_reference,
            //       }
            //
            //       //if the entry is from an application/ and we don't have quote get quote
            //       if (!this.objectIsNotEmpty(this.quote) && this.merchant_user_access.hasOwnProperty('application')){
            //           let application_data  = this.merchant_user_access.application.find(obj => {
            //               return obj.application_reference === application_reference
            //         });
            //       }
            //         //fetch and commit Application
            //       this[types.FETCH_APPLICATION_DATA](payload).then(obj => {
            //       }).then(obj => {
            //         });
            //     }
            // },
            setModalData: function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $('#elavon-gdpr-pdf').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            },
            mailEUDataProtectionOffice: function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                window.location.href = "mailto:EUDataProtectionOffice@elavon.com";
                objCommon.generalPreloader.hide_pl();
            },
            editDocument: function (section) {
                section['editing'] = true;
            },
            updateQuote(form_name = '#form', section = '', do_validate=true) {
                if(do_validate) {
                    if (!this.validateQuoteForm(form_name, section)) {
                        return
                    }
                }

                const url = `/quote/ajaxupdatequote`;
                let form = this.getFormData($(form_name)), vm = this;
                this.quote.section = form.section;

                //TODO don't update if quote wasn't changed.
                vm.getAxiosInstance().post(url, vm.quote).then(response => {
                    if (response['data']['result'] === 'SUCCESS') {

                        vm.notifySuccess(vm.lang('quote_updated_successfully'))
                        //only update on the business info. Everything else should hold their data as is
                        if (section !== 'section_equipment' && section !== 'section_pricing') {
                            response.data.quote = {...vm.quote, ...response.data.quote}
                            vm[types.COMMIT_QUOTE](response.data)
                        }
                    }
                })
            },
            validateForm: function (form_selector) {
                const validator =  $(`${form_selector}`).validate({ focusInvalid: false });
                const validate_form = $(`${form_selector}`).valid();

                if (validator.numberOfInvalids()) {
                    $('html, body').animate({
                        scrollTop: ($(validator.errorList[0].element).offset().top - 300)
                    }, 2000);
                }

                return validate_form;
            },
            getSelectedEquipmentOffer: function (offer){
                let selected_offer = {bundles: [], equipment_offering_external_id: offer.equipment_offering_external_id};
                if (offer.acquiring_only === '1') {
                    selected_offer.acquiring_only = '1';
                }
                let offerData = this.jsonCopy(offer)
                offerData.bundles = [];
                //merge equipment_list and bundle_packages into the bundles[]
                offerData.bundles.push(offer.equipment_list)
                offer.bundle_packages.forEach(obj => offerData.bundles.push(obj));

                offerData.bundles.forEach((bundle, bundle_index) => {
                    if (bundle.individual_item_only === '0' && bundle.selected === '0') {

                    } else if (bundle.individual_item_only === '0' && bundle.selected === '1') {
                        //selected  bundle_packages
                        selected_offer.bundles.push({
                            equipment_bundle_external_id: bundle.equipment_bundle_external_id,
                            bundle_name: bundle.bundle_name,
                            bundle_items: bundle.bundle_items,
                            selected: bundle.selected,
                            is_boarding_activated: bundle.is_boarding_activated,
                        })
                    } else if(bundle.individual_item_only === '1') {
                        //equipment_list
                        if (bundle.bundle_items.length > 0) {

                            let selected_bundle_items = [];
                            bundle.bundle_items.forEach((bundle_item, bundle_item_index) => {
                                if (!!bundle_item.selected || bundle_item.is_mandatory === '1') {
                                    selected_bundle_items.push(bundle_item)
                                }
                            })

                            if (selected_bundle_items.length > 0) {
                                selected_offer.bundles.push({
                                    equipment_bundle_external_id: bundle.equipment_bundle_external_id,
                                    bundle_name: bundle.bundle_name,
                                    bundle_items: selected_bundle_items,
                                    selected: '1',
                                    is_boarding_activated: '1',
                                })
                            }
                        }
                    }
                })

                return selected_offer;

            },
            validateQuoteForm: function (form_name, section = '') {
                //open all accordions before validating. Accordions don't validate nicely when closed.

                $('#form').find('[id^=heading_]').removeClass('collapsed')
                $('#form').find('[id^=collapse_]').addClass('show');

                let form_is_valid = this.validateForm(form_name);
                if (section === 'section_equipment'){
                    //TODO clean up.
                    //if no offering is selected throw error
                    //if offering is selected but no bundle item, throw error.
                    let is_valid_equipment = false, is_valid_online = false;

                    //validate Equipment offerings
                    if (this.objectIsNotEmpty(this.equipment_offer)) {
                        is_valid_equipment = this.checkEquipmentOfferIsSelected(this.equipment_offer)
                    }

                    //validate online offerings
                    if (this.objectIsNotEmpty(this.online_offer)) {
                        is_valid_online = this.checkEquipmentOfferIsSelected(this.online_offer, true);
                    }

            //if card acceptance is both check both are selected.
            //                     if  is online and is_valid_online is false, throw error
            //                     else if its equipment  and is_valid_equipment  is false throw error
            //                     else if is both and either is_valid_online or is_valid_equipment is false
                    if ((this.quote.payment_method === '2' || this.quote.payment_method === '3') && !is_valid_online) {
                        this.notifyError(this.lang('validation_error'), this.lang('please_select_atleast_equipment_in_online_offering'));
                        return false;
                    }
                    if ((this.quote.payment_method === '1' || this.quote.payment_method === '3') && !is_valid_equipment) {
                        this.notifyError(this.lang('validation_error'), this.lang('please_select_only_one_equipment_in_equipment_offering'));

                        // this.notifyError(this.lang('validation_error'), this.lang('please_select_atleast_equipment_in_equipment_offering'));
                        return false;
                    }

                    //if no errors set the data
                    if (is_valid_equipment) {
                        this.$set(this.quote, 'equipment_offer', this.getSelectedEquipmentOffer(this.equipment_offer));
                    }
                    if (is_valid_online) {
                        this.$set(this.quote, 'online_offer', this.getSelectedEquipmentOffer(this.online_offer));
                    }


                    // if (!is_valid_equipment && !is_valid_online){
                    //     this.notifyError('Validation Error', 'Please select an Offering');
                    //     return false;
                    // }
                }

                //validate acquiring offering
                if (section === 'section_pricing'){
                    let is_valid_pricing = false;
                    if (this.objectIsNotEmpty(this.quote.acquiring_offer)) {
                        is_valid_pricing = this.checkPricingIsSelected(this.quote.acquiring_offer);
                        if (!is_valid_pricing) {
                            this.notifyError(this.lang('validation_error'), this.lang('please_select_pricing'))
                            return false;
                        }
                        //check if any pricing is null
                        if (!!this.quote.pricing_has_error) {
                            this.notifyError(this.lang('validation_error'), this.lang('cannot_save_pricing'))
                            return false;
                        }
                    }
                }

                return form_is_valid;
            },
            doSignature: function () {
                // get user using matching email
                let owner = this.merchant.owners.find(owner => owner.owner_email == this.user.email && owner.is_signatory == '1');
                if (!!owner) {
                    if (this.isSignerUser) {
                        this.doStatusCheckMultiSigner(owner);
                    }
                    else {
                        location.replace(owner.signer_url);
                    }
                }
            },
            signerSignature: function (signatory) {
                    let url = `/application/mailsignature/${this.merchant.application_external_id}/`;

                    this.is_loading = true;
                    this.loading_message =  this.lang('sending_signature_link');

                this.getAxiosInstance().post(url, {signature_type: 'MAIL', signatory_id: signatory.id})
                    .then(res => {
                        if (res['data']['result'] === 'SUCCESS') {
                            this.is_loading = false;
                            this.notifySuccess(this.lang("signature_link_sent_successfully"));
                        } else {
                            this.is_loading = false;
                        }
                    });
            },
            formatSignerStatus: function(status) {
                return status == '1' ? this.lang('signed') : this.lang('merchant_signature_pending');
            },
            retrySignature: function () {
                this.refreshSignatureUrl();
            },
            refreshSignatureUrl: function () {
                // get user using matching email
                let owner = this.merchant.owners.find(owner => owner.owner_email == this.user.email && owner.is_signatory == '1');
                if (!!owner) {
                    let url = `/application/refreshsignature/${this.merchant.application_external_id}/`;

                    this.is_loading = true;
                    this.loading_message =  this.lang('refresh_signature_link');

                    this.getAxiosInstance().post(url, {owner_id: owner.owner_ref})
                        .then(res => {
                            if (res['data']['result'] === 'SUCCESS') {
                                this.is_loading = false;
                                this.notifySuccess(this.lang("signature_link_refreshed_successfully"));
                                owner.signer_url = res['data']['signature']['signer_url'];
                                location.replace(owner.signer_url);
                            }
                        });
                }
            },
            completeSignature: function () {
                let url = `/application/completesignature/${this.merchant.application_reference}/`;
                let vm = this;
                // Show Loading Modal
                this.is_loading = true;
                // Disable all clicks on page
                window.addEventListener("click", (e) => {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }, true);

                this.getAxiosInstance().post(url, {})
                    .then(res => {
                        if (res['data']['result'] === 'SUCCESS') {
                            vm.merchant['application_status_external_id'] = res['data']['application']['application_status_external_id'];
                            vm.merchant.signature_date = res['data']['application']['signature_date'];
                            vm.appStore.substatuses = res['data']['substatuses'];
                            // vm.$router.push({path: `${this.application_root_path}review/`});
                        }
                    })
                    .finally(() => {
                        // Show Loading Modal
                        this.is_loading = false;
                        // For any case, success or error we should redirect to review page (review url)
                        window.location.href =`${this.application_root_path}review/`;
                    });
            },
            doStatusCheckMultiSigner: function (signer_owner, show_loading = true) {
                let url = `/application/ajaxstatuscheck/${this.merchant.application_reference}/`;
                let vm = this;
                const payload = {
                    get_signer_details: '1',
                    get_application_documents: '1'
                };
                if (show_loading) {
                    this.is_loading = true;
                }

                let signer_details_owner = null;
                this.getAxiosInstance().post(url, payload)
                    .then(res => {
                        if (res['data']['result'] === 'SUCCESS') {
                            if(!!res['data']['signer_details']) {
                                signer_details_owner = res['data']['signer_details'].find(signer_detail => {
                                    return (signer_detail.hasOwnProperty('signer_ref') &&
                                            !!signer_detail.signer_ref &&
                                            signer_owner.owner_ref == signer_detail.signer_ref);
                                });
                            }
                            // Update Application Status
                            vm.merchant ['application_status_external_id'] = res['data']['application']['application_status_external_id'];
                        }
                        this.is_loading = false;

                        if (this.isAwaitingSignature && !!signer_details_owner && signer_details_owner.signer_url) {
                            location.replace(signer_details_owner.signer_url);
                        } else {
                            this.notifyError(this.lang('error'), this.lang('signatory_application_status_change'));
                        }
                    });
            },
            doStatusCheck: function (show_loading = true) {
                let url = `/application/ajaxstatuscheck/${this.merchant.application_reference}/`;
                let vm = this;
                const payload = {
                    get_signer_details: '1',
                    get_application_documents: '1'
                };
                if(show_loading) {
                    this.is_loading = true;
                    this.loading_message = this.lang('generating_agreement_text');
                }
                this.getAxiosInstance().post(url, payload)
                    .then(res => {
                        console.log('doStatusCheck', res);
                        if (res['data']['result'] === 'SUCCESS') {
                            // Update Application Documents
                            if(!!res['data']['application_documents']) {
                                vm.merchant.documents = res['data']['application_documents'];

                                let document = res['data']['application_documents'].find(document => document.document_sign_type === 'ELECTRONIC');
                                if (!!document && vm.agreemmentDocumentInterval) {
                                    //dead loop. Never clear
                                    window.clearInterval(vm.agreemmentDocumentInterval);
                                }
                            }
                            if(!!res['data']['signer_details']) {
                                res['data']['signer_details'].forEach(signer_detail => {
                                    vm.merchant.owners.map(owner => {
                                        if(owner.owner_ref == signer_detail.signer_ref) {
                                            owner.signer_url = signer_detail.signer_url;
                                        }
                                    });
                                })
                            }
                            // Update Application Status
                            vm.merchant ['application_status_external_id'] = res['data']['application']['application_status_external_id'];
                            if (!!res['data']['errors']) {
                                useApplicationStore()[types.SET_MERCHANT_VALIDATION_ERRORS](res['data']['errors']);
                                vm.appStore.has_validation_errors = '1';
                                vm.$router.push({path: `${vm.application_root_path}review/errors`});
                            }
                        }
                    });
            },
            getSectionTitle: function (section) {
                return this.lang(section.label);
            },
            openFirstSection: function () {
                this.sections[0].is_open = true;
            },
            toggleSection: function (section) {
                section.is_open = !section.is_open;
            },
            lockApplication: function () {
                let vm = this;
                let url = `/application/ajaxsubmitapplication/`;
                let application_ref = this.merchant.application_reference;
                let payload = {application_ref: vm.merchant.application_reference};
                if (vm.need_gdpr_block) {
                    payload['has_merchant_confirmed_gdpr'] = vm.quote.gdpr_agreement;  //submit button shows only if '1'
                    payload['marketing_opt_in'] = vm.quote.marketing_opt_in;
                }
                if (vm.show_extra_consent) {
                    payload['consent_bank_pci'] = vm.quote.consent_bank_pci;  //submit button shows only if '1'
                    payload['consent_proprietorship_share_data'] = vm.quote.consent_proprietorship_share_data;  //submit button shows only if '1'
                    payload['consent_opayo'] = vm.quote.consent_opayo;  //submit button shows only if '1'
                }

                vm.disableContinueBtn = true;
                setTimeout(function () {
                    vm.disableContinueBtn = false;
                }, 3000);

                this.getAxiosInstance()
                    .post(url, payload)
                    .then(response => {
                        if (response.data.result === 'SUCCESS') {
                            if (!!response['data']['errors']) {
                                useApplicationStore()[types.SET_MERCHANT_VALIDATION_ERRORS](response['data']['errors']);
                                this.appStore.has_validation_errors = '1';
                                this.merchant.has_validation_errors = '1';
                                this.$router.push({path: `${this.application_root_path}review/errors`});
                            } else {
                                this.notifySuccess(this.lang("application_submitted_successfully"));
                                this.sections.map(section => {
                                    section.editing = false;
                                    section.is_open = false;
                                });
                                location.href = `/application/view/${application_ref}/review/`
                            }
                        }
                    })
            },
            unlockApplication: function () {
                let vm = this;
                let url = `/application/unlock/${this.merchant.application_external_id}`;
                let application_ref = this.merchant.application_reference;
                this.getAxiosInstance()
                    .post(url, {application_ref: this.merchant.application_reference})
                    .then(response => {
                        if (response.data.result === 'SUCCESS') {
                            this.notifySuccess(this.lang("application_unlocked_successfully"));
                            this.appStore.substatuses = response['data']['substatuses'];
                            this.merchant.application_status_external_id = response['data']['application']['application_status_external_id'];

                            //reload the portal
                            let action = 'view';
                            if (vm.hasMerchantControl) {
                                action = 'edit';
                            }
                            location.href = `/application/${action}/${application_ref}/review/`;
                        }
                    });
            },
            formatMerchantStatus() {
                return this.formatSelectType(this.parameters, this.merchant.application_status_external_id, 'APPLICATION_STATUS_PARAM')
            },
            getSubstatusDescription: function (status) {
                return !!this.parameters?(this.parameters['APPLICATION_SUBSTATUS'].hasOwnProperty(status.substatus_external_id)
                    ? this.parameters['APPLICATION_SUBSTATUS'][status.substatus_external_id]['application_substatus'] : ''):'';
            },
            nextPage: function () {
                this.$router.push({path: `${this.application_root_path}review/signature`});
            },
            backPage: function () {
                let vm = this;

                let unfinished_application_exist = !!vm.unfinished_application;
                let unfinished_application = unfinished_application_exist ? vm.unfinished_application : null;

                let signer_needs_document_validation = vm.getSignerDocumentCategories().length > 0;

                let path_to = vm.application_root_path + 'documents/';
                if (vm.isSignerUser && signer_needs_document_validation && !vm.hasProofOfID()) {
                    path_to = vm.application_root_path + 'upload_documents/';
                }
                if (unfinished_application && vm.isMerchantViewAndUpdateDocument(unfinished_application)) {
                    path_to = vm.application_root_path + 'upload_documents/';
                }

                this.$router.push({path: path_to});
            },
            wasRecentlyUpdated: function (section) {
                return false;
            },
            backGroundFormValidation: async function(section, callback, suspend=null){
                let vm = this;
                return new Promise(async function(res,err){
                    let valid = false;
                    let p = new Promise(function(res,err){
                        setTimeout(function(){
                            section.editing = true;
                            section.is_open = true;

                            res();
                        },2000)
                    })
                    p.then(function(valid){
                        //enable hidden accordions on principals, equipments, supporting docs
                        $('[id^=heading_]').removeClass('collapsed')
                        $('[id^=collapse_]').addClass('show');
                        valid = callback(section.form_name)
                        section.editing = false;
                        section.is_open = false;
                        section.hasRequiredData = (!suspend) ? valid : section.hasRequiredData
                        section.wasRecentlyUpdated = (vm.appStore.quote.section === section.section_name) ? vm.appStore.quote.save_change : section.wasRecentlyUpdated;
                        section.wasRecentlyUpdated = (vm.appStore.merchant.section === section.section_name) ? vm.appStore.merchant.save_change : section.wasRecentlyUpdated;
                        section.wasRecentlyUpdated = (vm.appStore.outlets.length > 0 && !!vm.appStore.outlets[0].section && vm.appStore.outlets[0].section === section.section_name) ? vm.appStore.outlets[0].save_change : section.wasRecentlyUpdated;
                        ////console.log('outlet', vm.app_chain.outlets[0])
                        res(valid)
                    })

                    //return validation;
                });
            },
            hasRequiredData: async function (section, constructor) {
                if (this.review_load_complete && section.section_id === "section_documents" && constructor === 'MerchantData'){
                    //console.log('hasRequiredData', section.section_id)

                    if (this.signerOwner && this.signerOwner.hasOwnProperty('idpal_verification') &&  this.signerOwner.idpal_verification == '1'){
                        section.hasRequiredData = true;
                        return;
                    }

                    this.initDocumentValidationRulesByConfig()

                    this.validateDocumentsByConfig(this.appStore.merchant.documents)

                    section.hasRequiredData = true
                    Object.keys(this.document_categories_validation_rules).forEach((category_code) => {
                        let document_category_validation_rules = this.document_categories_validation_rules[category_code]
                        section.hasRequiredData = !!section.hasRequiredData ?
                            (document_category_validation_rules.count >= document_category_validation_rules.minimum) :
                            section.hasRequiredData
                    })

                    if(!!this.can_edit && section.is_editable && section.is_open && this.isOpenApplication) {
                        this.backGroundFormValidation(section, this.validateForm, true)
                    }

                }
                else {
                    if(!!this.can_edit && section.is_editable && section.is_open && this.isOpenApplication) {
                        this.backGroundFormValidation(section, this.validateForm)
                    }
                    else {
                        section.hasRequiredData = true;
                        section.wasRecentlyUpdated = false;
                    }
                }
            },
            changeDetect: function (old_data, new_data, response = false) {

                if(typeof(old_data) === 'object')
                {

                    Object.keys(old_data).map( (obj_key) => {
                        let old_value = old_data.hasOwnProperty(obj_key) ? old_data[obj_key] : null;
                        let new_value = new_data.hasOwnProperty(obj_key) ? new_data[obj_key] : null;

                        if (typeof (old_value) === 'object' && !!old_value && !!new_value && response !== true)
                        {
                            response = this.changeDetect(old_value, new_value, response)
                        }
                        else if (old_value !== new_value && !!old_value && !!new_value && response !== true)
                        {
                            response = true
                        }
                    })
                }

                if(new_data.hasOwnProperty('section'))
                {
                    old_data.save_change = response
                    new_data.save_change = response
                }

                return response
            },
            changeWatch: function (entity, constructor, entity_data, use, refs) {
               // debugger
                //if(entity[refs.new].constructor.name === constructor || ( refs.hasOwnProperty('alternative') && entity[refs.new].constructor.name === refs.alternative ) ){
                if (!!entity && Object.keys(entity[refs.new]).length > 0){

                    if(Object.keys(entity_data[refs.old]).length === 0){
                        entity_data[refs.old] = this.jsonCopy(entity[refs.new])
                    }else {
                        let change = this.changeDetect(entity_data[refs.old], entity[refs.new])
                        if (change)
                        {
                            entity[refs.new].save_change = change
                            entity_data[refs.old] = this.jsonCopy(entity[refs.new])
                        }
                    }

                    this.review_load_complete = true;
                    this.sections.map((section) => {
                        if(!!section && section.section_id !== 'section_generated_documents' && !!use.find(item => item === section.section_id))
                        {
                            this.hasRequiredData(section, constructor);
                        }
                    })
                }
                else
                {
                    let vm = this
                    setTimeout(function(){
                        vm.changeWatch(entity, constructor, entity_data, use, refs)
                    }, 1000)
                }
            },
            toggleExtraConsent: function(consent_opened_and_checked) {
                this.extra_consent_opened_and_checked = consent_opened_and_checked;
            },
            savePassword: function () {
                let vm = this;
                this.getAxiosInstance().post('/myaccount/ajaxsetpassword', this.password_form).then(response => {
                    if (response.data.result === 'SUCCESS') {
                        this.password_errors = [];
                        vm.notifySuccess(vm.lang('password_added_successfully'))
                        //$('#setPasswordModal').modal('hide');
                        let modalEl = document.querySelector('#setPasswordModal')
                        let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
                        modal.hide();
                        window.location.reload();

                    }else{
                        //use API error message instead
                        //let {errors} = response.data;
                        //this.password_errors = errors;
                    }
                })
            },
            formatCheckedPayPalCredentials: function(credentials) {
                let all_keys_present = true;
                let keyMap = {
                    channel_id: 'channelId',
                    partner_client_id: 'partnerClientId',
                    partner_payer_id: 'partnerId',
                    partner_logo_url: 'partnerLogoUrl',
                    return_url_for_done_page_button: 'returnToPartnerUrl',
                    merchant_id: 'merchantId',
                    product_intent_id: 'productIntentId',
                    integration_type: 'integrationType',
                    features: 'features',
                    show_permissions: 'showPermissions',
                };

                let allowed_empty_fields = ['partnerLogoUrl', 'features'];

                let credentialsObj = {};
                for (const [key, value] of Object.entries(keyMap)) {
                    if (!allowed_empty_fields.includes(value) && credentials[value].length === 0) {
                        all_keys_present = false
                    }
                    credentialsObj[key] = credentials[value];
                }

                return all_keys_present ? credentialsObj : null;
            },
            matchesUserEmail: function(email){
                if (email && this.user && this.user.hasOwnProperty('email')){
                    return email === this.user.email
                }
                return false;
            },
            isMaskedSection: function (section) {
                let vm = this;
                let masked_sections = {
                    section_business_details: vm.isPiiDataMaskedBank,
                    section_principals: vm.isPiiDataMaskedOwner,
                    section_documents: (vm.isPiiDataMaskedDocument || vm.isPiiDataMaskedOwner)
                };
                let is_section_masked = Object.entries(masked_sections).find(([masked_section, value]) => {
                    return masked_section === section;
                });

                return !!is_section_masked && is_section_masked.length > 1 ? is_section_masked[1] : false;
            }
        },
        computed: {
            ...mapState(useModuleStore,{

                support_phone: 'support_phone',
                system_parameters: 'parameters',
                user: 'user' }),
            ...mapState(useApplicationStore, {
                loading_document_upload:'loading_document_upload',
                app_chain: 'application',
                application:'application',
                parameters:'parameters',
                merchant:'merchant',
                application_users: 'application_users',
            }),
            // parameters: function () {
            //     return this.$parent.parameters;
            // },
            satisfy_extra_consent_block: function () {
                return (this.show_extra_consent === false) || (this.extra_consent_opened_and_checked);
            },
            show_extra_consent: function () {
                let vm = this;
                if (vm.alliance.contact_country === '616') {
                    return true;
                }

                let has_consent_submission_action = !!this.parameters && this.parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK')
                    && this.parameters.APPLICATION_PROCESS_ACTIONS_CHECK.hasOwnProperty('CONSENT_AND_SUBMISSION')
                    && this.parameters.APPLICATION_PROCESS_ACTIONS_CHECK.CONSENT_AND_SUBMISSION === true;
                if (has_consent_submission_action) {
                    return true;
                }

                return false;
            },
            substatuses: function () {
                return !!this.appStore?this.appStore.substatuses:[];
            },
          principalcanSign: function () {
            let owner = null;
            // get user using matching email
            if (!!this.merchant.owners && this.merchant.owners.length > 0) {
              owner = this.merchant.owners.find(owner => {
                return owner.is_signatory == '1' && owner.owner_email == this.user.email
              });
            }
            return !!owner;
          },
          multiplePrincipalsCanSign: function () {
            if (!!this.merchant.owners && this.merchant.owners.length > 0) {
              let owners = this.merchant.owners.filter(owner => owner.is_signatory == '1');
              return owners.length > 1;
            }
            return false;
          },
            principalHaveSigned: function () {
                let owner = null;
                // get user using matching email
                if (!!this.merchant.owners && this.merchant.owners.length > 0) {
                    owner = this.merchant.owners.find(owner => {
                        return owner.is_signatory == '1' && owner.owner_email == this.user.email && owner.signer_signed == '1';
                    });
                    return !!owner;
                }
                return !!owner;
            },
            hasAgreementDocuments: function () {
                const docs = !!this.merchant.documents ?
                    this.merchant.documents : [];
                const document = docs.find(document => document.document_sign_type === 'ELECTRONIC');
                return !!document;
            },
            outlets_array: function () {
                return !!this.appStore? this.appStore.outlets[0]:[];
            },
            showSetPassword: function () {
                let vm = this;
                let allowed_statuses = [
                    types.APP_STATUS_AWAITING_BOARDING_COMPLETE,
                    types.APP_STATUS_SUBMISSION_FAILED,
                    types.APP_STATUS_BOARDING_COMPLETE,
                    types.APP_STATUS_BOARDING_IN_PROGRESS,
                    types.APP_STATUS_AWAITING_SIGNATURE];

                if (!!this.parameters && this.parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK')
                    && this.parameters.APPLICATION_PROCESS_ACTIONS_CHECK.hasOwnProperty('SET_MERCHANT_PASSWORD')) {

                    let is_allowed = allowed_statuses.includes(this.applicationStatusKey) && this.user.has_password === false
                        && this.parameters.APPLICATION_PROCESS_ACTIONS_CHECK.SET_MERCHANT_PASSWORD === true;

                    return this.applicationStatusKey !== types.APP_STATUS_AWAITING_SIGNATURE ? is_allowed : (is_allowed && vm.signerHaveSigned);
                }

                return false;
            },
            updatedUser: function () {
                if (
                    !!this.application_users
                    && this.application_users.hasOwnProperty(this.user.user_external_id)
                ) {
                        return this.application_users[this.user.user_external_id];
                }
                return this.user;
            },
            showSetMfaDevice: function () {
                const vm = this;
                const allowed_statuses = [
                    types.APP_STATUS_AWAITING_BOARDING_COMPLETE,
                    types.APP_STATUS_SUBMISSION_FAILED,
                    types.APP_STATUS_BOARDING_COMPLETE,
                    types.APP_STATUS_BOARDING_IN_PROGRESS];

                const use_mfa = this.updatedUser?.use_mfa === true
                const has_active_mfa_device = this.updatedUser?.has_active_mfa_device
                const has_allowed_status = allowed_statuses.includes(this.applicationStatusKey) || this.applicationStatusKey === types.APP_STATUS_AWAITING_SIGNATURE && vm.signerHaveSigned

                // Hide set mfa button after being redirected from signing page
                let is_redirected_from_signing_page = !!window.location.pathname && window.location.pathname.includes('/signature/complete/');

                return use_mfa && !has_active_mfa_device && has_allowed_status && !is_redirected_from_signing_page;
            },
            payPalBoardingLink: function(){
                let vm = this;
                let link = '';//location.href
                if (vm.allowPayPalBoarding) {
                    let credentials = vm.paypal_boarding.credentials;
                    //overwrite credentials set dynamic credentials
                    credentials.returnToPartnerUrl =
                        `${window.location.origin}/application/view/${vm.merchant.application_reference}/review/`;
                    credentials.merchantId = vm.merchant.application_reference;

                    let environment = vm.paypal_boarding.hasOwnProperty('environment') ?
                        vm.paypal_boarding.environment : '';

                    let base_url = environment && environment === 'PRODUCTION' ? 'paypal.com' : 'sandbox.paypal.com';

                    let params = this.formatCheckedPayPalCredentials(credentials);

                    if (params) {
                        link = `https://www.${base_url}/bizsignup/partner/entry?`
                            +`&channelId=${params.channel_id}`
                            +`&partnerId=${params.partner_payer_id}`
                            +`&partnerClientId=${params.partner_client_id}`
                            +`&returnToPartnerUrl=${params.return_url_for_done_page_button}`
                            +`&partnerLogoUrl=${params.partner_logo_url}`
                            +`&merchantId=${params.merchant_id}`
                            +`&productIntentId=${params.product_intent_id}`
                            +`&features=${params.features}`
                            +`&showPermissions=${params.show_permissions}`
                            +`&integrationType=${params.integration_type}`;
                    }
                    console.log(link);
                }
                return link;
            },
            allowPayPalBoarding: function () {
                //return false;
                let paypal_config = this.paypal_boarding;
                return paypal_config && paypal_config.hasOwnProperty('credentials') &&
                    paypal_config.hasOwnProperty('PAYPAL_BOARDING') && paypal_config.PAYPAL_BOARDING;
            },
            signatories: function () {
                let vm = this;
                return this.merchant.owners.reduce(function(signatory_map, owner) {
                    if (owner.is_signatory == '1') {
                        signatory_map.push({
                            id: owner.owner_ref,
                            text: `${vm.formatTitle(owner.owner_title)} ${owner.owner_first_name} ${owner.owner_surname}`,
                            phone_code: owner.owner_phone_code,
                            phone_no: owner.owner_phone_no,
                            email: owner.owner_email,
                            signer_signed: owner.signer_signed,
                            signature_date: owner.signature_date|| '-',
                            signature_method: null,
                            signer_url: owner.signer_url
                        });
                    }
                    return signatory_map;
                }, []);
            },
            userCanEditInReviewPage: function () {
                return ((!this.isSignerUser && this.isOpenApplication) || this.showEditDocumentSignatory)
            },
            userCanEditDocumentsSession: function () {
                return this.merchant.merchant_to_upload_document === '1' && this.userCanEditInReviewPage && !this.isPiiDataMaskedDocument;
            },
        },
        watch: {
            'merchant.application_reference': {
                immediate: true,
                handler: function (val) {
                    let vm = this;
                    if (!!val && this.$route.params.signature_status == 'complete') {
                        this.completeSignature();
                    }

                    // do status check update status when document generation process is done
                    if (!!val && this.applicationStatusKey === types.APP_STATUS_DOCUMENT_PACKET_GENERATION_IN_PROGRESS) {
                        vm.statusCheckInterval = setInterval(function () {
                            vm.doStatusCheck()
                        }, 10000);
                    }
                }
            },
            'applicationStatusKey': {
                immediate: true,
                handler: function (val, oldVal) {
                    let vm = this;

                    if (val === types.APP_STATUS_OPEN && oldVal !== types.APP_STATUS_OPEN && !vm.isSignerUser) {
                        if (!vm.validateDocuments()) {
                            vm.backPage();
                            return;
                        }
                    }

                    // do status check update status when document generation process is done
                    if (!vm.statusCheckInterval && !!vm.merchant && val === types.APP_STATUS_DOCUMENT_PACKET_GENERATION_IN_PROGRESS) {
                        vm.statusCheckInterval = setInterval(function () {
                            vm.doStatusCheck(true)
                        }, 10000);
                    } else if(vm.statusCheckInterval && val !== types.APP_STATUS_DOCUMENT_PACKET_GENERATION_IN_PROGRESS) {
                        window.clearInterval(vm.statusCheckInterval);
                        this.is_loading = false;
                    }

                    // do status check to get agreement documents
                    if (!vm.agreemmentDocumentInterval && !vm.hasAgreementDocuments && !!vm.merchant && val === types.APP_STATUS_AWAITING_SIGNATURE && !vm.isSignerUser) {
                        vm.agreemmentDocumentInterval = setInterval(function () {
                            vm.doStatusCheck(false)
                        }, 10000);
                    }
                }
            },
            'appStore.quote': {
                immediate: true,
                handler: function (val) {
                    this.is_state_changed.quote = true;
                    let use = ['section_business_information', 'section_equipment', 'section_pricing'];
                    let refs = {'new': 'quote', 'old':'quote_data', 'alternative' : 'Object'}
                    this.changeWatch(this.appStore, 'Quote', this.app_chain_change, use, refs)

                }
            },
            'appStore.quote.equipment_offer': {
                immediate: true,
                handler: function (val) {
                    this.is_state_changed.quote = true;
                    let use = ['section_business_information', 'section_equipment', 'section_pricing'];
                    let refs = {'new': 'equipment_offer', 'old':'equipment_offer' }
                    if(!!this.appStore && this.appStore.quote.constructor.name === 'Quote')
                    {
                        this.changeWatch(this.appStore.quote, 'Object', this.app_chain_change.quote_data, use, refs)
                    }

                }
            },
            'appStore.merchant': {
                immediate: true,
                handler: function (val) {
                    this.is_state_changed.application = true;
                    let use = ['section_business_details', 'section_principals'];
                    let refs = {'new': 'merchant', 'old':'merchant_data' }
                    this.changeWatch(this.appStore, 'MerchantData', this.app_chain_change, use, refs)
                }
            },
            'outlets_array': {
                immediate: true,
                //deep: false,
                handler: function (val) {
                    if(!!this.appStore){
                    this.is_state_changed.outlet = true;
                    this.appStore.outlets.map((outlet) => {
                        let use = ['section_business_details', 'section_trading_details'];
                        let refs = {'new': '0', 'old':'outlet_data' }
                        // TODO find a way to deal with multiple outlets refs[new] = 0++
                        this.changeWatch(this.appStore.outlets, 'Outlet', this.app_chain_change, use, refs)
                    })
                }
                }
            },
            'appStore.merchant.documents': {
                immediate: true,
                handler: function (val) {
                    let use = ['section_documents'];
                    let refs = {'new': 'merchant', 'old':'merchant_data' }
                    this.changeWatch(this.appStore, 'MerchantData', this.app_chain_change, use, refs)

                }
            },
            'appStore.merchant.merchant_control': {
                immediate: true,
                handler: function (val) {
                    let vm = this;
                    if (val === '1') {
                        vm.need_gdpr_block = false; //if merchant has control, it has already done in business info
                    }
                    else {
                        vm.need_gdpr_block = true;
                    }
                }
            },
        }
    }
</script>

<style scoped>
button.button--submit-btn:disabled, button.button--submit-btn[disabled]{
    cursor: not-allowed !important;
}

.table-text td, .table-text th,
.table-text a {
    font-size: 11px;
}
</style>
